import type { FaireCategoryEntity } from "../../entity_types/category";

export const catalog_cat_womens_accessories: FaireCategoryEntity = {
  token: "catalog_cat_womens-accessories",
  type: "category",
  name: "Women's accessories",
  count: 35,
  meta: {
    source: "mock",
    importedAt: "2026-03-24T00:00:00.000Z",
    importedBy: "common-sets-db-backfill",
  },
};
